/* eslint-disable prefer-named-capture-group */
/* eslint-disable no-useless-escape */

import { empty } from '../helpers/helpers'
import {
  MENSAGEM_EMAIL_INVALIDO,
  MENSAGEM_CPF_INVALIDO,
  MENSAGEM_NASCIMENTO_INVALIDA,
  MENSAGEM_NOME_SOBRENOME_CARACTERES,
  MENSAGEM_NOME_SOBRENOME_INVALIDO,
  MENSAGEM_TAMANHO_SENHA,
  MENSAGEM_LETRA_MAIUSCULA_SENHA,
  MENSAGEM_LETRA_MINUSCULA_SENHA,
  MENSAGEM_NUMERO_SENHA,
  MENSAGEM_CARACTERE_ESPECIAL_SENHA,
  MENSAGEM_TELEFONE_INVALIDO,
} from './constantsValidadores'

export const validaEmailOuCPF = valor => {
  const valorSemEspacos = valor.replace( /\s/gu, '' )
  const isEmail = valorSemEspacos.includes( '@' )
  if ( isEmail ) {
    return validacaoEmail( valorSemEspacos )
  } else {
    return validacaoCPF( valorSemEspacos )
  }
}

export const validacaoCPF = cpf => {
  const cpfLimpo = cpf.replace( /[^\d]+/gu, '' )
  if ( cpfLimpo.length !== 11 || ( /^(\d)\1{10}$/u ).test( cpfLimpo ) ) {
    return MENSAGEM_CPF_INVALIDO
  }

  let soma = 0
  let resto

  for ( let digito = 1; digito <= 9; digito += 1 ) {
    soma += parseInt( cpfLimpo.substring( digito - 1, digito ), 10 ) * ( 11 - digito )
  }

  resto = ( soma * 10 ) % 11

  if ( resto === 10 || resto === 11 ) {
    resto = 0
  }
  if ( resto !== parseInt( cpfLimpo.substring( 9, 10 ), 10 ) ) {
    return MENSAGEM_CPF_INVALIDO
  }

  soma = 0
  for ( let digito = 1; digito <= 10; digito += 1 ) {
    soma += parseInt( cpfLimpo.substring( digito - 1, digito ), 10 ) * ( 12 - digito )
  }
  resto = ( soma * 10 ) % 11
  if ( resto === 10 || resto === 11 ) {
    resto = 0
  }
  if ( resto !== parseInt( cpfLimpo.substring( 10, 11 ), 10 ) ) {
    return MENSAGEM_CPF_INVALIDO
  }

  return null
}

export const validacaoEmail = email => {
  // eslint-disable-next-line require-unicode-regexp
  const VALID_EMAIL = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if ( empty( email ) || !VALID_EMAIL.test( email ) ) {
    return MENSAGEM_EMAIL_INVALIDO
  }
}

export const validacaoNome = nome => {
  const completeNameReGexp = /^([A-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'-.])/gu
  const specialChars = /[0-9!@#$%^&*()_+\-=\[\]{};:"\\|,<>\/?]+/gu
  const hasSpecialChars = specialChars.test( nome )
  let mensagemErro = ``
  if ( hasSpecialChars ) {
    mensagemErro = MENSAGEM_NOME_SOBRENOME_CARACTERES
  } else if ( empty( nome ) || !completeNameReGexp.test( nome ) ) {
    mensagemErro = MENSAGEM_NOME_SOBRENOME_INVALIDO
  }

  return mensagemErro
}

export const validacaoTelefone = telefone => {
  if ( !( telefone && telefone.length && typeof telefone.length !== 'undefined' ) ) {
    return MENSAGEM_TELEFONE_INVALIDO
  }

  const areaCode = parseInt( telefone.substring( 1, 3 ), 10 )
  if ( areaCode < 10 || areaCode % 10 === 0 ) {
    return MENSAGEM_TELEFONE_INVALIDO
  }

  if ( telefone.length === 15 || telefone.length === 14 ) {
    return null
  } else {
    return MENSAGEM_TELEFONE_INVALIDO
  }
}

export const validacaoDataNascimento = data => {
  const dt = new Date()
  const dia = data.substring( 0, 2 )
  const mes = data.substring( 3, 5 )
  const ano = Number( data.substring( 6, 10 ) )
  const anoAtual = dt.getFullYear()
  const isDiaInvalido = dia <= 0 || dia > 31
  const isMesInvalido = mes <= 0 || mes > 12
  const isAnoInvalido = ano <= 1900 || ano > anoAtual
  if ( data.length > 1 && data.length < 10 ) {
    return MENSAGEM_NASCIMENTO_INVALIDA
  } else if ( isDiaInvalido || isMesInvalido || isAnoInvalido ) {
    return MENSAGEM_NASCIMENTO_INVALIDA
  } else if ( data.length === 0 && data.length === 10 ) {
    return null
  }
}

export const validacaoSenha = senha => {
  const msgs = []

  if ( !senha || senha.length < 8 ) {
    msgs.push( MENSAGEM_TAMANHO_SENHA )
  }

  const hasUppercase = ( /[A-Z]/u ).test( senha )
  const hasLowercase = ( /[a-z]/u ).test( senha )
  const hasNumber = ( /[0-9]/u ).test( senha )
  const hasSpecialChar = ( /[!@#$%^&*(),.?":{}|<>]/u ).test( senha )

  if ( !hasUppercase ) {
    msgs.push( MENSAGEM_LETRA_MAIUSCULA_SENHA )
  }

  if ( !hasLowercase ) {
    msgs.push( MENSAGEM_LETRA_MINUSCULA_SENHA )
  }

  if ( !hasNumber ) {
    msgs.push( MENSAGEM_NUMERO_SENHA )
  }

  if ( !hasSpecialChar ) {
    msgs.push( MENSAGEM_CARACTERE_ESPECIAL_SENHA )
  }

  return msgs.length > 0 ? msgs.join( '\n' ) : null
}
